import React, { useState } from "react";

import axios from "axios";
import UserRequestedProductsPage from "./UserRequestedProducts";
import UserGrantedProductsPage from "./UserGrantedProducts";

import LoadingGif from "../../../assets/images/Spin_loader.gif"


function Status({setParentLoading, activeStatusTab}) {
  

    return (
        <div >
             
                {/* CONTENTS */}

                <div
                    style={{
                    width: "100%",
                    minHeight: "100vh",
                    overflowY: "auto",
                    backgroundColor: "white",
                    padding: "10px",
                    boxSizing: "border-box"
                }}
                >

                    {/* REQUESTED PRODUCTS */}

                    {activeStatusTab === "userrequestedproducts" &&
                        <div className="fade-container">
                          <UserRequestedProductsPage setParentLoading={setParentLoading} />
                        </div>
                    }

                    {/* GRANTED PRODUCTS */}

                    {activeStatusTab === "usergrantedproducts" &&
                        <div className="fade-container">
                           <UserGrantedProductsPage setParentLoading={setParentLoading} />
                        </div>
                    }

                    {/* REPLACEMENT PRODUCTS */}

                    {activeStatusTab === "userreplacementproducts" && <div className="fade-container">
                       <b>This page is under construction...</b>
                    </div>
                    }
                  


                </div>

        </div>
    )
}


export default Status;